import { useSelector, useDispatch } from 'react-redux';
import FJTextToImagePrompt from '../view/FJTextToImagePrompt';
import { memo, useCallback } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import FJActionModal from '../../../../redux/action/FJActionModal';
import FJTextToImageConstant from '../../../../constants/FJTextToImageConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImagePromptContainer = memo(function FJTextToImagePromptContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.textToImage.prompt);
    const promptStatus = useSelector(state => state.textToImage.promptStatus);
    const curGeneratingPromptImageUrl = useSelector(state => state.textToImage.curGeneratingPromptImageUrl);

    const changePrompt = useCallback(
        prompt => {
            dispatch(FJActionTextToImage.changePromptAction(prompt));
        },
        [dispatch],
    );

    const showUploadImageAsPromptModal = useCallback(() => {
        if (promptStatus !== FJTextToImageConstant.NORMAL) {
            return;
        }
        dispatch(FJActionModal.showUploadImageAsPromptModalAction());
    }, [dispatch, promptStatus]);

    const onCancel = useCallback(() => {
        if (promptStatus === FJTextToImageConstant.IMAGE_IMPORTING) {
            dispatch(FJActionTextToImage.cancelImageRecognitionAction());
        } else {
            dispatch(FJActionTextToImage.cancelAiOptimizingAction());
        }
    }, [dispatch, promptStatus]);

    const getInspire = useCallback(() => {
        dispatch(FJActionTextToImage.getInspireAction());
    }, [dispatch]);

    const aiOptimizing = useCallback(() => {
        dispatch(FJActionTextToImage.aiOptimizingAction());
    }, [dispatch]);

    return (
        <FJTextToImagePrompt
            prompt={prompt}
            changePrompt={changePrompt}
            promptStatus={promptStatus}
            showUploadImageAsPromptModal={showUploadImageAsPromptModal}
            imageUrl={curGeneratingPromptImageUrl}
            onCancel={onCancel}
            getInspire={getInspire}
            aiOptimizing={aiOptimizing}
        />
    );
});

export default FJTextToImagePromptContainer;
